export default function ExportApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getExports() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/export`));
        });
    }

    function getExportDocument(exportId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/export/document/${exportId}`));
        });
    }

    function createExport() {
        return buildRequest().then(function (req) {
            // POST to export/document endpoint without a date payload
            return makeRequest(req.post(`${baseUrl}/export/document`));
        });
    }

    function deleteExport(exportId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/export/${exportId}`));
        });
    }   

    return {
        getExports,
        getExportDocument,
        createExport,
        deleteExport
    }

}